//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconAlertTriangle(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M13 9.00003H11V14H13V9.00003Z" fill="currentColor" /><path d="M12 17.75C12.6904 17.75 13.25 17.1904 13.25 16.5C13.25 15.8097 12.6904 15.25 12 15.25C11.3096 15.25 10.75 15.8097 10.75 16.5C10.75 17.1904 11.3096 17.75 12 17.75Z" fill="currentColor" /><path d="M12 1.03003L2.6 17H4.92L12 4.97003L20.25 19H1.43L0.25 21H23.75L12 1.03003Z" fill="currentColor" /></svg>;
}
export default IconAlertTriangle;